module.exports = __webpack_public_path__ + "static/media/NO_DOGS.ca5ce445.svg";